module.exports = __webpack_public_path__ + "img/logo.95d682bc.png";